/*
* Copyright 2016 KabukiThemes. All rights reserved.
*/

var themeSettings = {
    breakpoint: 1000,
    selectors: {
        menuTitle: ".menu-title",
        headerMenu: ".header-menu",
        closeMenu: ".close-menu",
        movedElements: ".top-page-message, .header, .home-page-slider-wrap, .master-wrapper-content, .footer, .resp-nav-list, .home-page-main-banner",
        sublist: ".header-menu .sublist-wrap, .header-menu .wide-dropdown-wrap, .header-menu .wd-sublist-wrap",
        goToTop: ".go-to-top",
        overlayOffCanvas: ".overlayCanvas",
        searchBox: "div.search-box",
        searchBoxParentElem: ".search-box-wrap",
        navWrapper: ".resp-nav-list",
        headerLinksWrapper: ".header-line",
        headerLinksWrapperMobileInsertAfter: '.searchBoxParent',
        headerLinksWrapperDesktopPrependTo: '.header',
        shoppingCartLink: ".shopping-cart-link"
    }
}

var mainBody;
var pagePathname = location.pathname;
var IS_MOBILE = false;
var themeSettings;
var LAST_VIEWPORT_WIDTH = 0;
var parallaxActivated = false;
var contentSelectorPosition;
var contentSelectorPositionDefault;
var parallaxWrapperHeight;
var headerStickCondition;
var commentsPosition;
var viewportHeight;
var shopWideDropdownHeight;

//variables for the show/hide of the responsive nav wrapper element - go to hasScrolled() function
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $(themeSettings.selectors.navWrapper).outerHeight();


// HELPER FUNCTIONS

//get Android version
function getAndroidVersion(ua) {
    ua = (ua || navigator.userAgent).toLowerCase(); 
    var match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : false;
}

//detect IE9
var browser = {
    isIe: function () {
        return navigator.appVersion.indexOf("MSIE") != -1;
    },
    navigator: navigator.appVersion,
    getVersion: function() {
        var version = 999; // we assume a sane browser
        if (navigator.appVersion.indexOf("MSIE") != -1)
            // bah, IE again, lets downgrade version number
            version = parseFloat(navigator.appVersion.split("MSIE")[1]);
        return version;
    }
};

function isMobileDevice() {
   
   var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()) ? true : false;
        }
    };

    return isMobile.any();
}

function nano(template, data) {
  return template.replace(/\{([\w\.]*)\}/g, function(str, key) {
    var keys = key.split("."), v = data[keys.shift()];
    for (var i = 0, l = keys.length; i < l; i++) v = v[keys[i]];
    return (typeof v !== "undefined" && v !== null) ? v : "";
  });
}

function getSpikesViewPort() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    var result = { width: e[a + 'Width'], height: e[a + 'Height'] };
    return result;
}

function addSpikesWindowEvent(eventName, functionToCall) {
    if (window.addEventListener) window.addEventListener(eventName, functionToCall, false);
    else if (window.attachEvent) window.attachEvent("on" + eventName, functionToCall);
}

function hasScrolled() {
    if(getAndroidVersion() === false || parseFloat(getAndroidVersion()) !== 2.3){
        var st = $(window).scrollTop();
        var contentOffsetCondition = $('.header').offset().top < $(window).scrollTop();

        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        // If current position > last position AND scrolled past navbar...
        if (st > lastScrollTop && st > navbarHeight && contentOffsetCondition) {
            // Scroll Down
            if (!$(themeSettings.selectors.navWrapper).hasClass('nav-up')) {
                $(themeSettings.selectors.navWrapper).removeClass('nav-down').addClass('nav-up');
            }
        }
        else {
            // Scroll Up
            // If did not scroll past the document (possible on mac)...
            if (!$(themeSettings.selectors.navWrapper).hasClass('nav-down')) {
                if ((st + $(window).height()) < $(document).height()) {
                    $(themeSettings.selectors.navWrapper).removeClass('nav-up').addClass('nav-down');
                }
            }
        }

        lastScrollTop = st;
    }
}

function initResponsiveTheme(simulateMobileDevice, isInitialLoad) {
    
    IS_MOBILE = simulateMobileDevice;
        
    if(!isMobileDevice() && (simulateMobileDevice || isInitialLoad)) {
        checkDevice(isInitialLoad);
    }

    toggleMobileClass();
    menu_prepareTopMenu();
    attachOrDetachElements();
    handleAjaxSearch();
    if(isInitialLoad){
        addDetachableClickEvents();
        addClickEvents();
    }

    if(isInitialLoad && !isMobileDevice()) {
        addDesktopClickEvents();
    }

    if(IS_MOBILE){
        $('.header-line, .header-menu-parent, .header-links-list').removeAttr('style');
    }
    else{
        var headerElementsValues = getHeaderElementsValues();

        flyoutCartPreparation(headerElementsValues);
        headerMenuPreparation(headerElementsValues);
    }
}

function isBreakpointWidthHit() {
    var currentWidth = getSpikesViewPort().width;
    return (currentWidth <= themeSettings.breakpoint && LAST_VIEWPORT_WIDTH > themeSettings.breakpoint) || 
      (currentWidth > themeSettings.breakpoint && LAST_VIEWPORT_WIDTH <= themeSettings.breakpoint);
}

function scrollToPosition(position) {
    
    $('body,html').animate({ scrollTop: position }, 500);
}

function checkDevice(isInitialLoad){

    if(getSpikesViewPort().width <= themeSettings.breakpoint && (isBreakpointWidthHit() || isInitialLoad)){
        IS_MOBILE = true;
        LAST_VIEWPORT_WIDTH = getSpikesViewPort().width;
        initResponsiveTheme(true, false);
        setShoppingCartContentHeight();
        setFlyoutCartItemHeight();
        shopDropdownHover();   
    }
    else if(getSpikesViewPort().width > themeSettings.breakpoint && isBreakpointWidthHit()){
        IS_MOBILE = false;
        LAST_VIEWPORT_WIDTH = getSpikesViewPort().width;
        initResponsiveTheme(false, false);
        setShoppingCartContentHeight();
        setFlyoutCartItemHeight();
        shopDropdownHover();
    }
    
    if(!IS_MOBILE) {

        viewportHeight = $(window).height();
        
            addScrollbarToDropdown();
        
    }

    
        displaceBackButtonOnDesktop();
    
}

function menu_prepareTopMenu() {

    var menus = ".top-menu li";

    if (!IS_MOBILE) {
        $(".sublist-wrap.active").removeClass("active");
        $(".wide-dropdown-wrap.active").removeClass("active");
        $(".wd-sublist-wrap.active").removeClass("active");
        $(".plus-button.close").removeClass("close");

        $(menus).on('mouseenter', function () {
            $('a', $(this)).first().addClass('hover');
            $('.sublist-wrap', $(this)).first().addClass('active');
            $(".wide-dropdown-wrap", $(this)).first().addClass('active');
            $('.wd-sublist-wrap', $(this)).first().addClass('active');
        }).on('mouseleave', function () {
            $('a', $(this)).first().removeClass('hover');
            $('.sublist-wrap', $(this)).first().removeClass('active');
            $(".wide-dropdown-wrap", $(this)).first().removeClass('active');
            $('.wd-sublist-wrap', $(this)).first().removeClass('active');
        });

    }
    else {
        $(menus).off('mouseenter mouseleave');
        $(".sublist-wrap.active").removeClass("active");
        $(".wide-dropdown-wrap.active").removeClass("active");
        $(".wd-sublist-wrap.active").removeClass("active");
        $(".plus-button.close").removeClass("close");
    }
}

function toggleMobileClass() {
    if (IS_MOBILE) {
        mainBody.removeClass('desktop').addClass('mobile');
    }
    else {
        mainBody.removeClass('mobile').addClass('desktop');
    }
}

function addClickEvents() {

    $(".plus-button").on("click", function (e) {
        
        if(IS_MOBILE){
          $('.header-menu').perfectScrollbar('destroy');
        }
      
        var sublist = $(this).siblings(".sublist-wrap, .wide-dropdown-wrap, .wd-sublist-wrap");
        if ($(sublist).hasClass("active")) {
            $(sublist).removeClass("active");
        }
        else {
            if(IS_MOBILE) {
                $(this).parents().eq(2).animate({ scrollTop: 0 }, 180, function () {
                    $(sublist).addClass("active");
                });
            }
          else {
                $(sublist).addClass("active");
          }
        }
    });
  
    var scrollOffset = 0;

   if (!IS_MOBILE && $('body').hasClass('template-index')) {
        
        
            scrollOffset = $(".desktop .top-page-message").offset().top; 
        
    }

    $(themeSettings.selectors.goToTop).on("click", function () {
        
        scrollToPosition(scrollOffset);
    });
    
        
    $(window).on("scroll", function () {
        
        didScroll = true;
        
        if(!IS_MOBILE) {
            
            stickyNav(themeSettings.selectors.headerMenu, '.header');
            
            if ($(window).scrollTop() > 100) {// 100px - scroll barrier
                $(themeSettings.selectors.goToTop).addClass('show');
            }
            else {
                $(themeSettings.selectors.goToTop).removeClass('show');
            }
        }
     
      // activate the wheelScrollToHeaderMenu() when the page is scrolled to the top
      

      
        // if the sticky header is enabled, but the landing section and top page message are disabled
        // the header is position:fixed; by default, so the script below is unnecessary 
        
          if($('body').hasClass('desktop')){
            
                // when the top page message is enabled, but the landing section is not          
                headerStickCondition = $(window).scrollTop() >= $('.top-page-message').outerHeight();

              // the styling that avoids the jumping of the content is added via the func masterWrapperPaddingTop()
              if(headerStickCondition){
                $('.header').addClass('stick');
                $('#flyout-cart').css('top', $('.header').outerHeight());
              }
            
            
                // this is used with each of the if statements above
              else {
                $('.header').removeClass('stick');
                $('.master-wrapper-content').removeAttr('style');
                $('#flyout-cart').css('top', $('.header').outerHeight());
              }
                   
          }
        
      
      
      if($('body').hasClass('template-article')){
        if($('#comments .comment-list-wrap').length > 0){
            commentsPosition = $('#comments .comment-list-wrap').offset().top + -($(window).scrollTop());
        }
        else{
            commentsPosition = $('#comments').offset().top + -($(window).scrollTop());
        }
      }
    });
}

function stickyNav(target, refferer) {
    if (($(window).scrollTop() >= $(refferer).first().offset().top + $(refferer).height())) {
        $(target).addClass('stick');
    }
    else {
        $(target).removeClass('stick');
    }
}

function attachOrDetachElements() {

    var selectors = themeSettings.selectors;
    
    if (IS_MOBILE) {
        
        $(selectors.searchBox).detach().appendTo('.searchBoxParent');
        $(selectors.headerLinksWrapper).detach().insertAfter(selectors.headerLinksWrapperMobileInsertAfter);
        $(selectors.headerMenu).detach().insertAfter('.searchBoxParent');

        $(selectors.shoppingCartLink).off("hover.flyout-cart");
        $('.top-menu > li > .sublist-wrap, .top-menu > li > .wide-dropdown-wrap').css("display", "");
    }
    else {
        $(selectors.headerMenu).css({ 'height': '', 'top': '' });
        $(selectors.sublist).css({ 'height': '', 'top': '' });
        mainBody.css("overflow", "");
        $(selectors.headerMenu).detach().appendTo('.header-menu-parent');
        $(selectors.searchBox).detach().appendTo(selectors.searchBoxParentElem);
        $(selectors.headerLinksWrapper).detach().prependTo(selectors.headerLinksWrapperDesktopPrependTo);

        $(selectors.shoppingCartLink).on("hover.flyout-cart", function (e) {
            $('.flyout-cart').slideToggle(100, function () {
                $(this).css('overflow', '');
            });
            e.preventDefault();
        });
    }
}

function addDetachableClickEvents() {
    
    var selectors = themeSettings.selectors;
    
    $('.search-wrap > span').click(function () {
        $('.searchBoxParent').addClass('open');
        $(selectors.overlayOffCanvas).show(0).addClass('show');
        $('html, body').addClass('scrollYRemove');
    });

    $('.options', selectors.navWrapper).on("click", function () {
        $(selectors.headerLinksWrapper).addClass('open');
        $(selectors.overlayOffCanvas).show(0).addClass('show');
        $('html, body').addClass('scrollYRemove');
    });

    //open-close menu
    $(selectors.menuTitle).click(function () {
        $(selectors.headerMenu).addClass('open');
        $(selectors.movedElements).addClass('move');
        $(selectors.overlayOffCanvas).show(0).addClass('show');
        $('html, body').addClass('scrollYRemove');

        if (IS_MOBILE) {
            //removes the PERFECT SCROLL from the mobile menu while not open
            $('.header-menu, .sublist-wrap, .wide-dropdown-wrap, .wd-sublist-wrap').perfectScrollbar({
                swipePropagation: false,
                wheelSpeed: 2,
                suppressScrollX: true
            });
        }
    });

    $(selectors.closeMenu).click(function () {
        $(selectors.headerMenu).removeClass('open');
        $(selectors.movedElements).removeClass('move');
        $(selectors.overlayOffCanvas).removeClass('show').delay(300).hide(0);
        $('html, body').removeClass('scrollYRemove');

        if (IS_MOBILE) {
            //removes the PERFECT SCROLL from the mobile menu while not open
            $('.header-menu, .sublist-wrap, .wide-dropdown-wrap, .wd-sublist-wrap').perfectScrollbar('destroy');
        }
    });

    // canvas overlay click
    $(selectors.overlayOffCanvas).click(function () {
        $(selectors.sublist).removeClass("active");
        $(selectors.headerMenu).add($(selectors.filtersContainer)).removeClass('open');
        $('.searchBoxParent').removeClass('open');
        $(selectors.headerLinksWrapper).removeClass('open');
        $(selectors.movedElements).removeClass('move');
        $('.quick-and-cart-window').removeClass('show').delay(300).queue(function() { $(this).remove(); });
        $(selectors.overlayOffCanvas).removeClass('show').delay(300).hide(0);
        $('html, body').removeClass('scrollYRemove');

        if (IS_MOBILE) {
            //removes the PERFECT SCROLL from the mobile menu while not open
            $('.header-menu, .sublist-wrap, .wide-dropdown-wrap, .wd-sublist-wrap').animate({ scrollTop: 0 }, 180).perfectScrollbar('destroy');
        }
    });

    //close sublist
    $(".back-button").on("click", function () {
        $(this).parents().eq(1).removeClass("active");
        if (IS_MOBILE) {
            //removes the PERFECT SCROLL from the mobile menu while not open
            $('.header-menu').perfectScrollbar({
                swipePropagation: false,
                wheelSpeed: 2,
                suppressScrollX: true
            });
        }
    });
}


/* AJAX SEARCH */

// get all products infomation (title and handle)
function ajaxAllProducts() {
  var result = new Array();
  var searchURL = '/collections/all?view=ajax';
  
  $.ajax({
    type: 'GET',
    url: searchURL,
    beforeSend: function () {
      // to do
    },
    success: function (data) {
      
      var elements = $(data).find('.product-for-search');
      
      elements.each(function() {
        
        var title = $.trim(this.getAttribute('data-title'));
        var handle = $.trim(this.getAttribute('data-handle'));
        
        var item = new Object();
        item.title = title;
        item.handle = handle;
        
        result.push(item);
      });
    },
    dataType: 'html'
  });
  
  return result;
}

// search by ajax
function handleAjaxSearch() {
  var products = ajaxAllProducts();
  
  $( "#input-ajax" ).keyup(function() {
    var that = $(this);
    var keyword = $.trim(that.val().toLowerCase());
    $('#result-ajax').hide();
    
    if(keyword.length >= 3){
      var result = $('#result-ajax .wrapper-ajax').empty();
      
      for (var i = 0; i < products.length; i++) {
        var item = products[i];
        
        var title = item.title;
        var handle = item.handle;
        
        if(title.toLowerCase().indexOf(keyword) > -1){
          
          var markedString = title.replace(new RegExp('(' + keyword + ')', 'gi'), '<span class="marked">$1</span>');
          
          var template = '<li class="search-item"><a class="si-link" href="/products/'+ handle +'">'+ markedString +'</a></li>';
          result.append(template);
        }
      }
      
      if($('#result-ajax .wrapper-ajax li').length){
        $('#result-ajax').show();
      }
    }
    else{
      $('#result-ajax').hide();
    }
  });
  
  $(this).click(function(e) {
    if(!($(e.target).parent('#result-ajax').length > 0)) {
      $('#result-ajax').hide();
    }
  });
}


/* AJAX CART & QUICK VIEW */

function addDesktopClickEvents() {  
    $(".item-grid").on("click", ".addToCartAjaxButton", function(e){
        e.preventDefault();
        e.stopPropagation();

        if(IS_MOBILE) 
        {
            window.location = $(this).attr('data-productUrl');
            return;
        }

        var sizes = $(this).attr("data-productVariantsSize");
        if(sizes == 1)
        {
            var firstProductVariantId = $(this).attr("data-productVariantId");
            var quantity = $(this).prev("input").val();
            if(isNaN(quantity)){
              quantity = 1;
            }

            addProductToCartAjax(firstProductVariantId, quantity);
        }

        if(sizes > 1)
        {
            
                showQuickView(this);
            
        }

        
    });

    $(".item-grid").on("click", ".quick-view-button", function(e){
        e.preventDefault();
        e.stopPropagation();
      
        showQuickView(this);
    });

    $(document).on("click", ".quickViewWindowAddToCart", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        $('.quick-and-cart-window').removeClass('show').delay(300).queue(function() { $(this).remove(); });
      
        var quickViewWindow = $(this).parents('.quick-view-wrap').first();
        var productId = quickViewWindow.attr('data-productId');
        var firstProductVariantId = quickViewWindow.attr('data-firstProductVariantId');

        var productVariantId = firstProductVariantId;
        var selectElement = $('#quick-view-product-selector-' + productId);
        if(selectElement.length > 0){

            productVariantId = $('#quick-view-product-selector-' + productId + ' option:selected').val();
        }

        var overview = $(this).parents('.overview').first();
      
        var quantityItem = $(overview).find('.qty-input');
        var quantity = 1;
        if(quantityItem.length > 0){
          quantity = quantityItem[0].value;
        }

        addProductToCartAjax(productVariantId, quantity);
    });

    $(".sale-of-the-day-wrap").on("click", ".add-to-cart-button", function(e){
        
        e.preventDefault();
        e.stopPropagation();
      
        $('.overlayCanvas').show(0).addClass('show');

        if(IS_MOBILE) 
        {
            window.location = $(this).attr('data-productUrl');
            return;
        }

        var productId = $(this).attr('data-productId');
        var firstProductVariantId = $(this).attr('data-productVariantId');
        var productVariantId = firstProductVariantId;
        var selectElement = $('#sale-of-the-day-product-select-' + productId);
        if(selectElement.length > 0){

            productVariantId = $('#sale-of-the-day-product-select-' + productId + ' option:selected').val();
        }

        var quantityItem = $(this).parents('.sale-of-the-day-wrap').find('.qty-input');
        var quantity = 1;
        if(quantityItem.length > 0){
          quantity = quantityItem[0].value;
        }

        addProductToCartAjax(productVariantId, quantity);
    });
  
    $(document).on("click", ".close-window", function(e){
        e.preventDefault();
        e.stopPropagation();

        $('.quick-and-cart-window').removeClass('show').delay(300).queue(function() { $(this).remove(); });
        $('.overlayCanvas').removeClass('show').delay(300).hide(0);
    });
}

function showQuickView(element) {
    $('.overlayCanvas').show(0).addClass('show');
    var productId = $(element).attr("data-productId");
    var quantity = 1;
    if(!$(element).hasClass("quick-view-button"))
    {
        quantity = $(element).parents('.details').first().find('.productQuantity').val();
    }
    if($('#productQuickViewWindow-' + productId).length > 0){
        $('#productQuickViewWindow-' + productId).find('.qty-input').val(quantity);
        $('#productQuickViewWindow-' + productId).show();
    }
    else{
        var productHandle = $(element).attr("data-productHandle");
        if(typeof quantity == 'undefined'){
            quantity = 1;
        }
        
        var ratingId = $(element).parents('.item-box').find('.details').first().find('.spr-badge').attr('id');
        if(typeof ratingId == 'undefined'){
            ratingId = -1;
        }
      
        getProductAjaxAndShowQuickView(productId, productHandle, quantity, ratingId);
    }
}

function addProductToCartAjax(id, quantity) {  
    $.ajax({
        url: "/cart/add.js",
        type: "POST",
        cache: false,
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify({
            id: id,
            quantity: quantity
        }),
        dataType: "json"
    }).done(function(data) {
        showAddedToCartWindow(data, quantity);
        getShoppingCartAjax();
    }).fail(function () {
        //console.log("ERROR adding product to cart !");
        var data = {
            message: 'The product is not available!'
        };
      
        showAddedToCartWindow(data, quantity);            
    }).always(function () {
        setTimeout(function(){
            $('.quick-and-cart-window').addClass('show');
        });             
    });
}

function getShoppingCartAjax() {
    $.ajax({
      url: "/cart.js",
      type: "GET",
      cache: false,
      contentType: "application/json; charset=utf-8",
      dataType: "json"
    }).done(function(data) {
        updateShoppingCart(data);
        return;
    }).fail(function () {
        console.log("ERROR fetching the Shopping Cart !");
        return;
    });
}

function getProductAjaxAndShowQuickView(productId, handle, quantity, ratingId) { 

    var url = "/products/"+handle+".js";
  
    $.ajax({
        url: url,
        type: "GET",
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    }).done(function(data) {
        createQuickViewWindow(productId, data, quantity, ratingId);
    }).fail(function () {
        console.log("ERROR fetching the product !");
        return;
    });
}


/* REMOVE PRODUCTS FROM CART VIA AJAX */

function initializeRemoveProductFromCartAjax() {
    
    $("#flyout-cart").on("click" , ".product-remove", function(e) { 
        
        e.preventDefault();

        $(this).closest('li.item').addClass("removed");
        if($("#flyout-cart ul li").length == 1) {
            $("#flyout-cart .mini-shopping-cart-content").addClass("empty");
        }

        // add class removed to the table.cart item that is being removed from cart
        if($('body').hasClass('template-cart')) {
            var index = $(this).attr("data-index");
            
            var cartTableItemSelector = "table.cart tr[data-index=" + index + "]";
            $(cartTableItemSelector).addClass("removed");
        }
        
        removeProductViaAjax(this);
    });

    $("body.template-cart .master-wrapper-main").on("click" , ".product-remove", function(e) {

        e.preventDefault();

        $(this).closest('li.mobile-shopping-cart-item').addClass("removed");
        $(this).closest('table.cart tr').addClass("removed");
        removeProductViaAjax(this);
  });
    $("body.template-cart .master-wrapper-main").on("click" , ".update-qty", function(e) {

        e.preventDefault();
        var qty = $(this).parent().find(".qty-input").val();
        var updatedHref = $(this).attr("href") + "&quantity=" + qty;
        $(this).attr("href", updatedHref);
        removeProductViaAjax(this);
    });
}

function removeProductViaAjax(product) {
    
    var deleteURL = $(product).attr("href");

    $.ajax({
    method: 'GET',
    url: deleteURL
    })
    .done(function (data) {

        getShoppingCartAjax();

        if($('body').hasClass('template-cart')) {

            var pageBodyHtml = $(data).find(".page-body");
            $(".page-body").replaceWith(pageBodyHtml);

            var mobileCartHtml = $(data).find(".mobile-shopping-cart-wrap");
            $(".mobile-shopping-cart-wrap").replaceWith(mobileCartHtml);

            setMobileCartListItemHeight();
        }

    })
    .fail(function (jqXHR, textStatus, errorThrown) {
    })
    .always(function() {
    });
}

function setMobileCartListItemHeight() {
    
    if($('body').hasClass('template-cart')) {

        var items = $('ul.mobile-shopping-cart li');
        items.each(function() {
            $(this).css("height", $(this).outerHeight() + "px");
        });
    }
}

function setFlyoutCartItemHeight() {

    $('#flyout-cart ul li').each(function() {
        if(getSpikesViewPort().width <= themeSettings.breakpoint) {
            $(this).css("height", "");
        }
        else {
            $(this).css("height", $(this).outerHeight() + "px");
        }
    });
}

function setShoppingCartContentHeight() {

    var miniShoppingCartElement = $('#flyout-cart .mini-shopping-cart-content');
    // remove the inline height previously set, so that the outerHeigth uses the actual height of the element
    // and not using the previous set, already outdated inline height set
    miniShoppingCartElement.css("height", "");
    
    if($('#flyout-cart ul.items li').length == 1 && getSpikesViewPort().width > themeSettings.breakpoint) {

        miniShoppingCartElement.css("height", miniShoppingCartElement.outerHeight() + "px");
    }    
}



/* MISC FUNCTIONS */

function addSliderToSaleOfTheDay() {

    $('.sale-of-the-day-wrap .picture-list').leanSlider({
        directionNav: '#slider-direction-nav',
        controlNav: '#slider-control-nav',
        directionNavPrevBuilder: function(prevText){
            return '<a href="#" class="lean-slider-prev">' + '<span class="btn-char">&larr;</span>' + '<span class="btn-text">' + prevText + '</span>' +'</a>';        
        },
        directionNavNextBuilder: function(nextText){
            return '<a href="#" class="lean-slider-next">' + '<span class="btn-char">&rarr;</span>' + '<span class="btn-text">' + nextText + '</span>' +'</a>';        
        },
        controlNavBuilder: function(index, slide){
            return '<a href="#" class="lean-slider-control-nav">'+ (index + 1) +'</a>';
        }
        
        
    });
    if($('.sale-of-the-day-wrap .picture-list li').length < 2){
        $('#slider-direction-nav').hide();
        $('#slider-control-nav').hide();
    }
}

function addSliderToProductPagePictureList() {

    $('.product-page .picture-list').leanSlider({
        directionNav: '#slider-direction-nav',
        controlNav: '#slider-control-nav',
        directionNavPrevBuilder: function(prevText){
            return '<a href="#" class="lean-slider-prev">' + '<span class="btn-char">&larr;</span>' + '<span class="btn-text">' + prevText + '</span>' +'</a>';        
        },
        directionNavNextBuilder: function(nextText){
            return '<a href="#" class="lean-slider-next">' + '<span class="btn-char">&rarr;</span>' + '<span class="btn-text">' + nextText + '</span>' +'</a>';        
        },
        controlNavBuilder: function(index, slide){
            return '<a href="#" class="lean-slider-control-nav">'+ (index + 1) +'</a>';
        }
        
        
    });
    if($('.product-page .picture-list li').length < 2){
        $('#slider-direction-nav').hide();
        $('#slider-control-nav').hide();
    }
}

function addSliderToLatestBlog() {

    $('.posts-list').leanSlider({
        directionNav: '#blog-direction-nav',
        directionNavPrevBuilder: function(prevText){
            return '<a href="#" class="lean-slider-prev">' + '<span class="btn-char">&larr;</span>' + '<span class="btn-text">' + prevText + '</span>' +'</a>';        
        },
        directionNavNextBuilder: function(nextText){
            return '<a href="#" class="lean-slider-next">' + '<span class="btn-char">&rarr;</span>' + '<span class="btn-text">' + nextText + '</span>' +'</a>';        
        }
    });
}

function addInstagramFeed() {

    var imagesCount = 0;
    
        imagesCount = 3;
    
  
    var feed = new Instafeed({
        get: "user",
        
            limit: imagesCount,
        

        

        resolution: "standard_resolution",
        userId: 0,
        accessToken: "",
        
        template: '<a href="{{link}}" target="_blank"><img src="{{image}}" /></a>'
        
    });

    feed.run();  
}

function FilterAndInsertImages(data, imagesCount) {
  var filterImages = new Array();
  
    for(i = 0; i < data.length; i++)
    {
        if(data[i].tags.indexOf('') >= 0)
        {
            filterImages.push(data[i]);
            imagesCount--;
            if(imagesCount == 0)
                break;
        }
    }

    var instagramHtml = "";
    for(i = 0; i < filterImages.length; i++)
    {
        var template = '<a href="{image.link}" target="_blank"><img src="{image.src}" /></a>'

        var imageData = {
            image : {
                link: filterImages[i].link,
                src: filterImages[i].images["standard_resolution"].url
            }
        }
        instagramHtml += nano(template, imageData);
    }

    $("#instafeed").html(instagramHtml)
}

function instagramHoverEffect() {

  $('#instafeed > a').each( function() { 
    $(this).append('<div class="insta-itam-hover"></div>');
    $(this).hoverdir(); 
  });
};

function addTwitterFeed() {

    var config = {
        'id': '',
        'domId': 'twitter-news',
        'maxTweets': 3
    }

    twitterFetcher.fetch(config);
}

function getCartTotalPrice(price){
    var moneyFormat = "";
    return Shopify.formatMoney(price, moneyFormat);
}

function getHeaderElementsValues() {
    var headerFullHeight = $('.header').outerHeight(); 
    var headerPaddingRight = $('.header').css('padding-right');
    var headerLogoWidth = $('.header-logo').css('width');
    var headerLineWidth = $('.header-line').css('width');

    return {
        headerFullHeight: headerFullHeight,
        headerPaddingRight: headerPaddingRight,
        headerLogoWidth: headerLogoWidth,
        headerLineWidth: headerLineWidth
    };
}

function flyoutCartPreparation(elemValues) {
    var flyoutCartTop = parseInt(elemValues.headerFullHeight);
    var flyoutCartRight = parseInt(elemValues.headerPaddingRight) * -1;
    var flyoutCartWidth = (parseInt($('.desktop #flyout-cart').css('width')) - flyoutCartRight) * -1;

    $('#flyout-cart').css('top', flyoutCartTop);
    $('#flyout-cart').css('right', flyoutCartWidth);
}

function headerMenuPreparation(elemValues) {
    var headerMenuMarginLeft = parseInt(elemValues.headerLogoWidth) + 50;
    var headerMenuMarginRight = parseInt(elemValues.headerLineWidth) + 50;

    if(headerMenuMarginLeft >= headerMenuMarginRight){
        $('.header-menu-parent').css('left', headerMenuMarginLeft).css('right', headerMenuMarginLeft);
    }
    else {
        $('.header-menu-parent').css('left', headerMenuMarginRight).css('right', headerMenuMarginRight);
    }
}

function productShareButtonsPreparation(){
    var pageUrl;

    function openWindow(url) {
        window.open(url , 'newwindow', 'width=' + 640 + ', height=' + 480 + ', top=' + 0 + ', left=' + 0);
    }
    $('ul.networks-list li.network-item a').click(function(e) {
        e.preventDefault();
        return openWindow(this.href);
    });


    if(mainBody.hasClass('template-product')){
        pageUrl = window.location.href;
    }
    else {
        pageUrl = window.location.href + $('.sale-of-the-day-wrap .product-title-link').attr('href');
    }

    $('#twitter-share').attr('href', ('https://twitter.com/share?url=' + pageUrl));
    $('#pinterest-share').attr('href', "javascript:void((function()%7Bvar%20e=document.createElement('script');e.setAttribute('type','text/javascript');e.setAttribute('charset','UTF-8');e.setAttribute('src','http://assets.pinterest.com/js/pinmarklet.js?r='+Math.random()*99999999);document.body.appendChild(e)%7D)());");    
    $('#facebook-share').attr('href', ('https://www.facebook.com/sharer.php?u=' + pageUrl)); 
    $('#google-share').attr('href', ('https://plus.google.com/share?url=' + pageUrl));
    $('#linkedin-share').attr('href', ('https://www.linkedin.com/shareArticle?mini=true&url=' + pageUrl));
    $('#reddit-share').attr('href', ('https://reddit.com/submit?url=' + pageUrl));   
}

function EnableFancyBoxWhenCloudZoomEnabled() {

     $(".gallery").on("click", ".mousetrap", function () {
      
          var imgSources = new Array();
          function imgItem(source){
            this.src = source;
          }
          
          $('.gallery a.picture-link').each(function(){
            imgSources.push( new imgItem($(this).attr('href')));
          });
          var indexOfHighlightedImage = 0;
          for (var i = 0; i < imgSources.length; i++) {
            if(imgSources[i].src == $('.gallery .lean-slider-slide.current a.picture-link').attr('href')){
              indexOfHighlightedImage = i;
              break;
            }
          }
          
          $.magnificPopup.open({
            items: imgSources,
            type: 'image',
            removalDelay: 300,
            gallery: {
              enabled: true
            }
          }, indexOfHighlightedImage);
    });
}

function initializeMagnificPopup() {

    $('.popup-link').magnificPopup(
    {
        type: 'image',
        removalDelay: 300,
        gallery: {
            enabled: true
        }
    });  
}

function scrollToHeaderMenu() {
  
 $('.btn-scroll-to-menu').click(function(){
      
      parallaxActivated = true;

      // when the button is clicked, set the value of parallaxActivated to true, to ensure
      // that the same process isn't triggered by the mousewheel/DOMMouseScroll event during
      // the animation
      // Also turn off the mousewheel/DOMMouseScroll at the end of the animation       
      $('body, html').animate({
        scrollTop: $(".desktop .header").offset().top
      }, 900, function(){
        $(window).off('mousewheel DOMMouseScroll');
      });   
    });  
}

function wheelScrollToHeaderMenu() {
  
  var contentWrapperSelector = 'body,html';
  
  $(window).on('mousewheel DOMMouseScroll', function(event) {
    
    // prevent the default behaviour of both scrolling upwards and downwards
    event.preventDefault();
    
    // check to see the position of the content wrapper and if the parallax effect was already triggered
    if(contentSelectorPosition == 0 && !parallaxActivated){
      
        // activate the fucntionality only on downwards scroll
        if (event.originalEvent.wheelDelta < 0 || event.originalEvent.detail > 0) {
          
          // increase the contentSelectorPosition variable by 1, to avoid 
          // this functionality activating again during the first triggering
          contentSelectorPosition++;
          
          // scroll down to the end of the landing section 
          // After the scroll down is finished, turn off the mousewheel/DOMMouseScroll event
          // and reset the contentSelectorPosition to its default value of 0, so that if the user
          // scrolls to the top of the page, the event could be triggered again
          $(contentWrapperSelector).animate({
            scrollTop: $('.home-page-main-banner').outerHeight()
          },900, function(){
              $(window).off('mousewheel DOMMouseScroll');
              contentSelectorPosition = contentSelectorPositionDefault;
          });  

        }
    }
  });
}

function mobileCollectionsSelectPreparation() {

    if($("#collections-select-id") != undefined && $("#collections-select-id").length > 0) {

        document.getElementById("collections-select-id").onchange = function() {
            window.location.href = this.value;
        };

        var tagsCount = $('#collections-select-id option').length;
        for(i = 0; i < tagsCount; i++) {
            if(pagePathname == $('#collections-select-id option').eq(i).attr('value')) {
                $('#collections-select-id option').eq(i).attr('selected', 'selected');
                break;
            }
        }    
    }
}


function addScrollbarToDropdown() {

    
        var differenceBetweenContentAndViewport = $('.top-page-message').height() + $('.header').outerHeight();
    

    if(viewportHeight < (shopWideDropdownHeight + differenceBetweenContentAndViewport)){
        $('.wide-dropdown').css('max-height', (viewportHeight - differenceBetweenContentAndViewport));
    }
    else {
        $('.wide-dropdown').removeAttr('style');
    }
}

function displaceBackButtonOnDesktop() {

    if(!IS_MOBILE){
        if($('.wide-dropdown > .back-button').is(':first-child')){
            $('.wide-dropdown > .back-button').appendTo('.wide-dropdown');
        }
    }
    else {
        if($('.wide-dropdown > .back-button').is(':last-child')){
            $('.wide-dropdown > .back-button').prependTo('.wide-dropdown');
        }        
    }
}

(function($){
    $.fn.extend({
    customStyle : function(options) {
            return this.each(function() {
                var currentSelected = $(this).find(':selected');
                $(this).after('<span class="customStyleSelectBox"><span class="customStyleSelectBoxInner">'+currentSelected.text()+'</span></span>').css({position:'absolute', opacity:0,fontSize:$(this).next().css('font-size')});
                var selectBoxSpan = $(this).next();
                var selectBoxWidth = parseInt($(this).width()) - parseInt(selectBoxSpan.css('padding-left')) -parseInt(selectBoxSpan.css('padding-right'));            
                var selectBoxSpanInner = selectBoxSpan.find(':first-child');
                selectBoxSpan.css({display:'inline-block'});
                selectBoxSpanInner.css({width:selectBoxWidth, display:'inline-block'});
                var selectBoxHeight = parseInt(selectBoxSpan.height()) + parseInt(selectBoxSpan.css('padding-top')) + parseInt(selectBoxSpan.css('padding-bottom'));
                $(this).height(selectBoxHeight).change(function() {
                    selectBoxSpanInner.text($(this).find(':selected').text()).parent().addClass('changed');
                });
         });
    }
    });
})(jQuery);

function shopDropdownHover() {
    if(!IS_MOBILE){
        $(document).on('mouseenter', '.shop-dropdown-item', function(){
            // using stop() in order to stop the current animation if a new one is started
            // useful when hover multiple times so that the events are not queued an executed all of them
            $('.wide-dropdown-wrap').stop().slideDown();
        }).on('mouseleave', '.shop-dropdown-item', function(){
            // using stop() in order to stop the current animation if a new one is started
            // useful when hover multiple times so that the events are not queued an executed all of them
            $('.wide-dropdown-wrap').stop().slideUp(400, function(){
             $(this).removeAttr('style');
            });
        });
    }
    else{
        $(document).off('mouseenter mouseleave', '.shop-dropdown-item');
    }
}

function blogDirectionsNavPosition() {

  var initializePosition = function() {
    var blogDirectionsNavTop = 0;
    
    if($('.post.current .post-picture').length) {
        blogDirectionsNavTop = $('.post.current .post-picture').outerHeight() + 40; //the number is the space between the image the buttons
    }      
      
      $('.blog-directions-nav').css('top', blogDirectionsNavTop);

  };
  
  initializePosition();
  
  //set the position according to the prev/next post's picture or the absence of one
  $('.blog-directions-nav a').on('click', initializePosition);
}

function masterWrapperPaddingTop() {
  
  
    var paddingTop = $('.top-page-message').outerHeight() + $('.header').outerHeight();
    $('.header').css('top', $('.top-page-message').outerHeight());
  
  
  $('.master-wrapper-page').css('padding-top', paddingTop);
}

function initializeCommentsAnchor(){

    if($('#comments .comment-list-wrap').length > 0) {
        commentsPosition = $('#comments .comment-list-wrap').offset().top;
    }
    else {
        commentsPosition = $('#comments').offset().top;
    }

    $('.comments-count').on('click', function(e){
        
        e.preventDefault();
        scrollToPosition(commentsPosition - 150);
    });
}

function flyoutCartStickyHeaderVersion(){
    // when you have sticky header enabled, this function limits the height of the flyoutCart
    // to the bottom point of the viewport. A scroll appears if the items inside the flyoutCart
    // exceed the viewport
    var headerHeight = $('.header').outerHeight();
    var flyoutCartSetHeight = viewportHeight - headerHeight;

    $('.desktop .flyout-cart .mini-shopping-cart-wrap').css('max-height', flyoutCartSetHeight);
}

$(window).on('beforeunload', function() {
  
  if(mainBody.hasClass('template-index')) {
    $(window).scrollTop(0);
  }
});

window.onload = function () {

    shopWideDropdownHeight = $('.wide-dropdown-wrap').height();

    if($('body').hasClass('desktop')){
      
    }
  
    if(getAndroidVersion() === false || parseFloat(getAndroidVersion()) !== 2.3){
        //show/hide responsive nav wrapper feature exectution
        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);
    }

    addSpikesWindowEvent("resize", function(){ checkDevice(false); });
    addSpikesWindowEvent("orientationchange", function(){ checkDevice(false); });

    
  
    if($('body').hasClass('template-index')){
        blogDirectionsNavPosition();   
    }

    $('select').customStyle();
  
            
  
    if($('body').hasClass('template-article')){
      if($('.post-body > p').eq(0).children('img').length == 0 || $('.post-body img').length == 0){
          $('.article-wrapper').addClass('no-img');
      }
    }
  
    
        masterWrapperPaddingTop();
    

    if(browser.isIe() && browser.getVersion() <= 9){
      $('body,html').removeAttr('style');
    }  
  
    if($('body').hasClass('template-article') && $('#comments').length > 0){
        initializeCommentsAnchor();
    }

    
        flyoutCartStickyHeaderVersion();
    

    
        if(!IS_MOBILE){
            addScrollbarToDropdown();
        }
    

    
        displaceBackButtonOnDesktop();
        

    
        $('.page-loader-effect').fadeOut(200);
    
};

$(document).ready(function () {
    viewportHeight = $(window).height();
    mainBody = $('body');
  
    

    

    if(mainBody.hasClass('template-index')){
        addSliderToLatestBlog();
        blogDirectionsNavPosition();

        addSliderToSaleOfTheDay();
        productShareButtonsPreparation();
        initializeMagnificPopup();

              
                
    } 
    
    if(mainBody.hasClass('template-product')){
        addSliderToProductPagePictureList();
        productShareButtonsPreparation();
        initializeMagnificPopup();        
    }
    if(mainBody.hasClass('template-collection')){
        mobileCollectionsSelectPreparation();
    }

    initResponsiveTheme(true, true);

    initializeRemoveProductFromCartAjax();
    setShoppingCartContentHeight();
    setFlyoutCartItemHeight();
    setMobileCartListItemHeight(); 
});